
import React from 'react';

const Hero: React.FC = () => {
  const handleContactSales = () => {
    window.REACT_APP_NAVIGATE('/contact');
  };

  return (
    <section className="relative bg-gradient-to-br from-blue-50 to-indigo-100 py-20 lg:py-32">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10" 
           style={{
             backgroundImage: `url('https://public.readdy.ai/ai/img_res/b0286d4f1ab000dafc54a714524c6ad9.jpg')`
           }}>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
              The Operating System for Business
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Zoho One helps growing businesses win more customers, manage their employees, track their finances, and holistically handle their operations on one unified system.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8">
              <button className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                Activate Free Trial
              </button>
              <button 
                onClick={handleContactSales}
                className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Contact Sales
              </button>
            </div>
            
            <ul className="text-sm text-gray-600 space-y-2">
              <li className="flex items-center justify-center lg:justify-start">
                <i className="ri-check-line text-green-500 mr-2"></i>
                Free for 30 days
              </li>
              <li className="flex items-center justify-center lg:justify-start">
                <i className="ri-check-line text-green-500 mr-2"></i>
                No card details required
              </li>
              <li className="flex items-center justify-center lg:justify-start">
                <i className="ri-check-line text-green-500 mr-2"></i>
                Free support and training
              </li>
            </ul>
          </div>
          
          <div className="flex justify-center lg:justify-end">
            <img 
              src="https://readdy.ai/api/search-image?query=Zoho%20One%20business%20dashboard%20interface%20showing%20unified%20applications%2C%20CRM%20sales%20pipeline%2C%20project%20management%20tools%2C%20financial%20analytics%2C%20HR%20management%20system%2C%20modern%20cloud%20software%20interface%20with%20multiple%20app%20icons%20and%20data%20visualization&width=600&height=500&seq=zoho-dashboard&orientation=landscape"
              alt="Zoho One Dashboard"
              className="w-full max-w-lg h-auto rounded-xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
